import Firebase from 'firebase'

let config = {
  apiKey: 'AIzaSyCSfZwMkaKKvPP71Okg9kJZraJvNTPWsWg',
  authDomain: 'meshi-meishi.firebaseapp.com',
  databaseURL: 'https://meshi-meishi.firebaseio.com',
  projectId: 'meshi-meishi',
  storageBucket: 'meshi-meishi.appspot.com'
}

const firebaseApp = Firebase.initializeApp(config)

export default firebaseApp



// WEBPACK FOOTER //
// ./src/firebaseApp.js